import React, {useContext} from "react";
import {Context} from "../index";
import {getCustomerPortalUrl} from "../http/userAPI";
import {Button} from "react-bootstrap";

const AccountSuspendedAlert = ({ onOpenCustomerPortal }) => {
    const { user } = useContext(Context);
    return (
        <div
            className="alert alert-danger mt-3 mx-auto text-start p-3"
            role="alert"
            style={{ maxWidth: 640 }}
        >
            <h5 className="alert-heading mb-2">Dear {user?.user?.username},</h5>
            <h5 className="alert-heading mb-2">
                Your Account is Suspended or Deleted, what next?
            </h5>

            <p className="mb-2">
                We’re truly sorry this happened. We know how discouraging it can feel, and we want you to know:
                <strong> this situation is fixable</strong>. New members sometimes run into issues like this, and
                our Support Team often helps restore access once everything is clarified.
            </p>

            <p className="mb-2">
                The suspension was triggered by our automated safety checks (a “soulless machine,” as we like to joke).
                It may have flagged something that needs a quick human review. Below are the most common reasons:
            </p>

            <ol className="mb-3 ps-4">
                <li>
                    <strong>Non-unique Amazon Review ID.</strong> The “R…” code in the link appears to have been used
                    to confirm another assignment. Reusing the same Amazon review for multiple assignments can be flagged.
                </li>
                <li>
                    <strong>Review date earlier than assignment start.</strong> The review seems to have been published
                    before the assignment began, so it may look unrelated to the work on this task. We understand mistakes happen,
                    but this can be viewed as misleading to the author.
                </li>
                <li>
                    <strong>Duplicate review content.</strong> The same reviewer name, identical text and date detected across several
                    confirmations for the same book.
                </li>
                <li>
                    <strong>Unusual balance activity.</strong> Patterns that look like attempts to artificially increase earnings/bonuses (Virt).
                </li>
                <li>
                    <strong>Same reviewer identity across multiple accounts.</strong> Multiple accounts are allowed,
                    but each must use a distinct reviewer identity.
                </li>
            </ol>

            <p className="mb-2">
                <strong>Another possibility:</strong> you may have <strong>deleted your account yourself</strong> previously.
                In that case, you’ll see this suspended message when trying to sign in with the same email.
            </p>

            <p className="mb-2">
                If that’s what happened, your <strong>subscription may still be active</strong> on our billing side.
                You can manage or cancel it via your Customer Portal:
            </p>

            {onOpenCustomerPortal && (
                <div className="my-3 d-flex justify-content-center align-items-center">
                    <Button
                        variant="success"
                        onClick={onOpenCustomerPortal}
                    >
                        <i className="bi bi-credit-card me-2" />
                        Open Customer Portal
                    </Button>
                </div>
            )}


            <p className="mb-2">
                If you believe this is a mistake — <strong>please don’t worry</strong>. It happens, and we’re here to help.
                Send a short message to our Support Team, and we’ll take a closer look. In many cases, once details are clarified,
                accounts are restored and everything ends well.
            </p>

            <p className="mb-2">
                For quick verification, please write from the email linked to this account:
                <strong> {user?.user?.email} </strong> and include your internal ID:
                <strong> {user?.user?.id} </strong>.
            </p>

            <p className="mb-0">
                Support: <a href="mailto:support@virtalibry.com">support@virtalibry.com</a>
                <br />
                You’re not alone — we’ve got you. Thank you for your patience and trust.
                <br />
                With care, the Virtalibry Team.
            </p>
        </div>


    );
};

export default AccountSuspendedAlert;